$(function(){
    $('#language_name').on('change', function(event){
        var $selected_option = $(this).find('option:selected'),
        code = $selected_option.data('code');
        $('#language_code').val(code);
    });
});